import ActionPlanQuestion from './ActionPlanQuestion';
import NpsQuestion from './NpsQuestion';
import NpsTextQuestion from './NpsTextQuestion';

import type { QuestionKey, OverlayQuestionProps } from './types';

export const questionRegistry: Record<
  QuestionKey,
  (props: OverlayQuestionProps) => JSX.Element
> = {
  ActionPlanQuestion,
  NpsQuestion,
  NpsTextQuestion,
};
